import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getKeycloak } from 'react-router-keycloak';

const CustomLogout = () => {
  const history = useHistory();

  useEffect(() => {
    const keycloak = getKeycloak();
    if (keycloak) {
      // Clear localStorage tokens
      localStorage.removeItem('authToken');
      localStorage.removeItem('authTokenParsed');
      localStorage.removeItem('authRefreshToken');
      localStorage.removeItem('refreshTokenParsed');
      localStorage.removeItem('idToken');
      localStorage.removeItem('idTokenParsed');

      keycloak.logout({ redirectUri: window.location.origin + '/login' });
    }
  }, []);

  return null;
};

export default CustomLogout;
